import React from "react";
import "./Loading.scss";

function Loading() {
  return (
    <div>
      <div className="dots">
        <div className="dot dot-1"></div>
        <div className="dot dot-2"></div>
        <div className="dot dot-3"></div>
      </div>
    </div>
  );
}

export default Loading;
